import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ElementRef,
    Input,
    OnDestroy,
    ViewChild
} from '@angular/core';
import { DelayService } from '@trademe/tangram';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
    // eslint-disable-next-line @angular-eslint/component-selector
    selector: 'show-more-text-field',
    templateUrl: './show-more-text-field.component.html',
    styleUrls: ['./show-more-text-field.component.scss'],
    standalone: false
})
export class ShowMoreTextFieldComponent implements AfterViewInit, OnDestroy {
    @ViewChild('descriptionElement', { static: true })
    descriptionElement: ElementRef;

    /* a hacky solution for ellipsis (especially to be able to work on IE 11) */
    maxLines = 5;
    isMoreThanMaxLines$ = new BehaviorSubject<boolean>(false);
    showAll$ = new BehaviorSubject<boolean>(true);

    private _destroyed$: Subject<void> = new Subject<void>();

    @Input() displayText: string;

    constructor(private _changeDetectorRef: ChangeDetectorRef, private _delayService: DelayService) {
    }

    ngOnDestroy(): void {
        this._destroyed$.next();
    }

    ngAfterViewInit() {
        /* a hacky solution for ellipsis (especially to be able to work on IE 11) */
        const descriptionHeight = this.descriptionElement.nativeElement.offsetHeight;
        const descriptionLineHeight = parseInt(getComputedStyle(this.descriptionElement.nativeElement).getPropertyValue('line-height'), 10);
        const descriptionLines = descriptionHeight / descriptionLineHeight;
        const isMoreThanMaxLines = descriptionLines > this.maxLines;
        this.isMoreThanMaxLines$.next(isMoreThanMaxLines);
        this.showAll$.next(!isMoreThanMaxLines);

        // delaying in event loop to make sure template gets the updates
        this._delayService.createDelay(0).subscribe(() => {
            this._changeDetectorRef.markForCheck();
        });
    }

    onShowMore() {
        this.showAll$.next(!this.showAll$.value);
    }
}
